import { DefaultDataServiceConfig, EntityMetadataMap } from '@ngrx/data';

import { environment } from 'projects/registro-personas-empresas/src/environments/environment';

const entityMetadata: EntityMetadataMap = {
  ActividadGrupoEspecie: {},
  // Actividad: {},
  Comercializacion: {},
  Especie: {},
  GrupoEspecie: {},
  GrupoEspecieTipoActividad: {},
  Laboratorio: {},
  SubActividad: {},
  SubActividadEspecie: {},
  TipoAnalisisLaboratorio: {},
  EstadoActividad: {},
  TipoComercializacion: {},
  TipoDivisorMuestra: {},
  TipoEquipamientoLaboratorio: {},
  TipoSubActividad: {},
  Deposito: {},
  TipoMovilidad: {},
  TipoEquipamientoProcesamiento: {},
  TipoSexoBiologico: {}
};

const pluralNames = {
  ActividadGrupoEspecie: 'ActividadesGrupoEspecie',
  // Actividad: 'Actividades',
  Comercializacion: 'Comercializaciones',
  Especie: 'Especies',
  EstadoActividad: 'EstadosActividad',
  GrupoEspecie: 'GruposEspecie',
  GrupoEspecieTipoActividad: 'GruposEspecieTipoActividad',
  Laboratorio: 'Laboratorios',
  SubActividad: 'SubActividades',
  SubActividadEspecie: 'SubActividadesEspecie',
  TipoAnalisisLaboratorio: 'TiposAnalisisLaboratorio',
  TipoComercializacion: 'TiposComercializacion',
  TipoDivisorMuestra: 'TiposDivisorMuestra',
  TipoEquipamientoLaboratorio: 'TiposEquipamientoLaboratorio',
  TipoSubActividad: 'TiposSubActividad',
  Deposito: 'Depositos',
  TipoMovilidad: 'TiposMovilidad',
  TipoEquipamientoProcesamiento: 'TiposEquipamientoProcesamiento',
  TipoSexoBiologico: 'TiposSexoBiologico'
};

export const defaultDataServiceConfig: DefaultDataServiceConfig = {
  root: environment.apiUrl,
  entityHttpResourceUrls: {
    ActividadGrupoEspecie: {
      entityResourceUrl: environment.apiUrl + '/actividadesGruposEspecie/',
      collectionResourceUrl: environment.apiUrl + '/actividadesGruposEspecie/'
    },
    Comercializacion: {
      entityResourceUrl: environment.apiUrl + '/comercializaciones/',
      collectionResourceUrl: environment.apiUrl + '/comercializaciones/'
    },
    Especie: {
      entityResourceUrl: environment.apiUrl + '/especies/',
      collectionResourceUrl: environment.apiUrl + '/especies/'
    },
    EstadoActividad: {
      entityResourceUrl: environment.apiUrl + '/estadosActividad/',
      collectionResourceUrl: environment.apiUrl + '/estadosActividad/'
    },
    GrupoEspecie: {
      entityResourceUrl: environment.apiUrl + '/gruposEspecie/',
      collectionResourceUrl: environment.apiUrl + '/gruposEspecie/'
    },
    GrupoEspecieTipoActividad: {
      entityResourceUrl: environment.apiUrl + '/gruposEspecieTipoActividad/',
      collectionResourceUrl: environment.apiUrl + '/gruposEspecieTipoActividad/'
    },
    Laboratorio: {
      entityResourceUrl: environment.apiUrl + '/laboratorios/',
      collectionResourceUrl: environment.apiUrl + '/laboratorios/'
    },
    SubActividad: {
      entityResourceUrl: environment.apiUrl + '/subActividades/',
      collectionResourceUrl: environment.apiUrl + '/subActividades/'
    },
    SubActividadEspecie: {
      entityResourceUrl: environment.apiUrl + '/subActividadesEspecie/',
      collectionResourceUrl: environment.apiUrl + '/subActividadesEspecie/'
    },
    TipoAnalisisLaboratorio: {
      entityResourceUrl: environment.apiUrl + '/tiposAnalisisLaboratorio/',
      collectionResourceUrl: environment.apiUrl + '/tiposAnalisisLaboratorio/'
    },
    TipoComercializacion: {
      entityResourceUrl: environment.apiUrl + '/tiposComercializacion/',
      collectionResourceUrl: environment.apiUrl + '/tiposComercializacion/'
    },
    TipoDivisorMuestra: {
      entityResourceUrl: environment.apiUrl + '/tiposDivisorMuestra/',
      collectionResourceUrl: environment.apiUrl + '/tiposDivisorMuestra/'
    },
    TipoEquipamientoLaboratorio: {
      entityResourceUrl: environment.apiUrl + '/tiposEquipamientoLaboratorio/',
      collectionResourceUrl: environment.apiUrl + '/tiposEquipamientoLaboratorio/'
    },
    TipoSubActividad: {
      entityResourceUrl: environment.apiUrl + '/tiposSubActividad/',
      collectionResourceUrl: environment.apiUrl + '/tiposSubActividad/'
    },
    Deposito: {
      entityResourceUrl: environment.apiUrl + '/depositos/',
      collectionResourceUrl: environment.apiUrl + '/depositos/'
    },
    TipoMovilidad: {
      entityResourceUrl: environment.apiUrl + '/tiposMovilidad/',
      collectionResourceUrl: environment.apiUrl + '/tiposMovilidad/'
    },
    TipoEquipamientoProcesamiento: {
      entityResourceUrl: environment.apiUrl + '/tiposEquipamientoProcesamiento/',
      collectionResourceUrl: environment.apiUrl + '/tiposEquipamientoProcesamiento/'
    },
    TipoSexoBiologico: {
      entityResourceUrl: environment.apiUrl + '/tiposSexoBiologico/',
      collectionResourceUrl: environment.apiUrl + '/tiposSexoBiologico/'
    }
  }
};

export const entityConfig = {
  entityMetadata,
  pluralNames
};
